module.exports = __webpack_public_path__ + "static/media/coppiaGLina.4bdce299.jpg";